import { Component, ContentChild, Input, TemplateRef } from '@angular/core'

import { SelectItemGroup } from 'primeng/api'

import { FilterType } from '@app/components/configure-filters/filter.constants'

import { Localizable, StaticDropDown } from './generic'

/**
 *
 * Support component for GenericListComponent, see that component for example usage.
 *
 */
@Component({
  selector: 'app-generic-column',
  template: '',
})
export class GenericColumnComponent {
  // column name (== field name)
  @Input() key!: string
  @Input() title!: string
  @Input() tooltip?: string
  // control the filter widget for this column
  @Input() filterType: FilterType = FilterType.TEXT
  // list of options for the filter select dropdown, when the above `filterType` is 'select'
  @Input() filterOptions: StaticDropDown[] | SelectItemGroup[] | Localizable[] = []
  // column name to provide for the filter parameter, in case it's different from the 'key'
  @Input() filterLabelField: string = 'label_en'
  // the field name to use as the 'filter name' parameter (aka django filter fieldname), defaults to column `key`
  @Input() filterKey?: string
  // the field name containing the value to filter on: defaults to 'value'
  @Input() filterValueField?: string
  // indicate if this column can be used for mobile view
  @Input() isMobileColumn: boolean = false
  // css class to apply to the non-header cells
  @Input() cellClass?: string
  // css class to apply to header cells
  @Input() cellHeadingClass?: string
  // column name to provide for the sort parameter, in case it's different from the 'key'
  @Input() sortKey?: string
  @Input() enableSort: boolean = true
  @Input() minWidth?: string = '30px'
  @Input() maxWidth?: string = 'auto'
  // for the filter m/select: whether the options should be 'grouped' according to the primeng group parameter
  @Input() group: boolean = false
  @Input() showMatchModes: boolean = true
  @Input() matchMode: string = 'contains'

  // optional template for data presentation
  @ContentChild(TemplateRef) template?: TemplateRef<any>
  // optional template for filter select list options
  @ContentChild('filterOptionsTemplate') filterOptionsTemplate?: TemplateRef<any>

  checkedFilterGroups = []
}
